import AdvertiserApi from '@/api/AdvertiserApi'

const actions = {
  async GET({ commit }, { advertiserId }) {
    const res = await AdvertiserApi.fetchAdvertiser(advertiserId)
    const advertiser = res.item
    commit('INITIALIZE', { advertiser })
  },
  INITIALIZE({ commit }, { advertiser }) {
    commit('INITIALIZE', { advertiser })
  },
  RESET({ commit }) {
    const advertiser = {}
    commit('INITIALIZE', { advertiser })
  },
}

export default actions
